<template>
  <main-layout>
    <b-row class="w-100 m-0" style="height: calc(-189px + 100vh)">
      <!--    <h3 class="float-left">Discussions</h3>-->
      <b-col class="h-100 p-0" v-if="isAdmin" cols="4">
        <b-list-group>
          <b-list-group-item>
            <b-form-input v-model="search" placeholder="Rechercher un élève"/>
          </b-list-group-item>
          <b-list-group-item
              v-for="d in filteredDiscussions()"
              :key="d.user_id"
              button
              @click="select(d)"
              :active="d.active">
            <!--            <b-btn size="sm" variant="primary">-->
            <!--              <b-icon-arrow-up-left/>-->
            <!--            </b-btn>-->
            {{ getLabel(d) }}
            <notif-message id="notif" :discussions="d.id"></notif-message>
            <b-btn variant="outline-primary" @click="$router.push({name:'EleveView', params:{id:d.user_id}})">
              <b-icon-arrow-up-left/>
            </b-btn>
          </b-list-group-item>
        </b-list-group>
      </b-col>
      <b-col class="h-100 p-0 pt-3 pb-2" :cols="isAdmin ? 8 : 12" style="max-width: 1400px; margin: auto">
        <b-alert variant="warning" dismissible :show="beta">
          Ceci est une version béta
        </b-alert>
        <chat :discussion="id" :key="chatID"></chat>
      </b-col>
    </b-row>
  </main-layout>
</template>

<script>
import Chat from "@/components/chat";
import {Auth, Discussion, User} from "@/js/caller";
import NotifMessage from "@/components/NotifMessage";

export default {
  name      : "MessagerieVue",
  components: {NotifMessage, Chat},
  data() {
    return {
      beta       : false,
      discussions: [],
      id         : "",
      chatID     : "",
      isAdmin  : Auth.IsAdmin(),
      // admin
      search: "",
      users : [],
    }
  },
  methods: {
    async getDiscussions() {
      this.discussions = await Discussion.GetDiscussions();
      if (this.discussions.length > 0) {
        this.select(this.discussions[0])
      }
    },
    async getUser() {
      this.users = await User.ActiveUser()
                             .then(res => res.map(({clef_mail, ...u}) => {
                               return {user_id: clef_mail, ...u}
                             }));
    },
    filteredDiscussions() {
      if (this.search === "") {
        return this.discussions;
      }
      return this.discussions.concat(
          ...this.users.filter(u => !(this.discussions.map(d => d.mail).includes(u.mail)))
      ).filter(d => this.getLabel(d).toLowerCase().indexOf(this.search.toLowerCase()) !== -1);
    },
    async select(d) {
      this.discussions.forEach(d => d.active = false)
      d.active = true;
      if (!d.id) {
        d.id = await Discussion.Open(d.user_id)
        this.discussions.push(d);
      }
      this.search = "";
      this.id = d.id;
      this.setChatID();
      this.search = "";
    },
    getLabel(d) {
      const main = d.prenom || d.mail || "Visiteur_" + d.user_id.slice(-4);
      return `${main}${d.mail && d.main !== main ? ' - ' + d.mail : ''}`;
    },
    reload() {
      this.isAdmin = Auth.IsAdmin();
      this.id = "";
      this.getDiscussions();
      if (this.isAdmin) {
        this.getUser();
      }
      this.setChatID();
    },
    setChatID() {
      this.chatID = this.id + new Date().getTime();
    },
  },
  created() {
    Auth.Register(Auth.Events.Role, () => {
      this.reload();
    })
    this.getDiscussions();
    if (this.isAdmin) {
      this.getUser();
    }
  }
}
</script>

<style scoped>
.list-group-item {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding-left: 4rem;
  margin-left: -1px;
}

.list-group {
  height: 100%;
  overflow-y: auto;
  display: block;
}

.alert {
  position: absolute;
  left: 50%;
  transform-origin: center;
  transform: translateX(-50%);
}

#notif {
  transform: translateY(-50%);
  top: 50%;
  left: calc(100% - 2rem);
}

.btn {
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  border-bottom: 0;
  border-top: 0;
  border-left: 0;
}

.active > .btn-outline-primary {
  color: #007bff;
  background-color: #fff;
}

.active > .btn-outline-primary:hover {
  color: #fff;
  background-color: #007bff;
}
</style>